import React from "react"
import { Button } from "../ui/button"
import { Link, useLocation } from "react-router-dom"
import { ScrollReveal } from "../ui/scroll-reveal"
import { EventCategory } from "../../lib/analytics"
import { safeTrackEvent } from "../../lib/analytics-utils"

export function ServicesCTA() {
  const location = useLocation();
  
  const handleCtaClick = () => {
    safeTrackEvent({
      category: EventCategory.Engagement,
      label: 'engagement_services_schedule_consultation',
      context: {
        sourcePage: location.pathname,
        destinationPage: '/contact'
      }
    });
  };

  return (
    <section className="container relative py-20 pb-32 text-center">
      <ScrollReveal>
        <div className="max-w-2xl mx-auto space-y-8">
          <h2 className="text-3xl font-semibold tracking-tight">Ready to Build Sustainable AI Capability?</h2>
          <p className="text-xl text-muted-foreground font-light">
            Let's discuss how our unique approach turns AI investments into lasting organisational capability.
          </p>
          <Button 
            asChild 
            size="lg" 
            className="text-lg px-10"
            onClick={handleCtaClick}
          >
            <Link to="/contact">Schedule Your Consultation</Link>
          </Button>
        </div>
      </ScrollReveal>
    </section>
  )
} 